import { html, type TemplateResult } from 'lit';

/**
 * Pixel-Art Back Arrow Icon SVG
 * Rendered on a 16x16 pixel grid with crispEdges shape rendering.
 */
export function iconPixelArrowLeft(size = 14): TemplateResult {
  return html`
    <svg
      width="${size}"
      height="${size}"
      viewBox="0 0 16 16"
      fill="currentColor"
      shape-rendering="crispEdges"
      style="display: inline-block; vertical-align: -0.15em; flex-shrink: 0;"
    >
      <path d="M6 3h2v2H6zM4 5h2v2H4zM2 7h2v2H2zM4 9h2v2H4zM6 11h2v2H6zM4 7h11v2H4z" />
    </svg>
  `;
}
